module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: "https://datachain.art/api",
    // Локал турших горим. Getter нь production-д хараахан deploy хийгдээгүй тул
    // локал сервер рүү хандана. Production руу буцаахдаа эдгээр хоёр мөрийг сольж
    // тайлбарлана (мөн api_v2-г тэнд deploy хийсэн байх шаардлагатай).
    //REAPI_URL: "http://localhost:8880/v2",
    REAPI_URL: "https://datachain.art/api_v2/v2",
  },
  // Татсан зураг/видеог үйлчлэх хаяг. Постын `media.image`-д зөвхөн ФАЙЛЫН НЭР
  // хадгалагддаг тул эндээс бүтэн URL угсарна. REAPI_URL-тэй хамт солино:
  // локал сервер өөрийн татсан зургаа, production нь DataChainMedia санг өгнө.
  media: {
    //BASE_URL: "http://localhost:8880/images/DataChainMedia",
    BASE_URL: "https://datachain.art/api/images/DataChainMedia",
  },
  reports: {
    // "Хэвлэлийн тойм" товч ЗӨВХӨН эдгээр судалгаан дээр харагдана.
    // Одоогоор: "Монгол банк". Товч харагдахаас гадна хандах эрхийг сервер
    // талд шалгана (api_v2/routes/reports.js доторх REPORT_TASK_IDS болон
    // судалгааны whitelist) — энд нэмэхдээ тэндхийг мөн хамт шинэчилнэ.
    KHEVLELIIN_TOIM_TASK_IDS: ["6a880881bc4a4d6cd79e56d3"],
  },
};
